import { render, staticRenderFns } from "./LiveAuditions.vue?vue&type=template&id=dda9b68e&scoped=true&"
import script from "./LiveAuditions.vue?vue&type=script&lang=js&"
export * from "./LiveAuditions.vue?vue&type=script&lang=js&"
import style0 from "./LiveAuditions.vue?vue&type=style&index=0&id=dda9b68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda9b68e",
  null
  
)

export default component.exports